import humps from "humps";
import { times, forEach } from "lodash-es";
import { format, parse, subHours, isBefore } from "date-fns";
import { enUS } from "date-fns/locale";
import { localeTranslator } from "@/utils/global.util";

export const MINS_LIST = ["00", "15", "30", "45"];

export const timeOptions = (startTime, endTime, minsList = MINS_LIST) => {
  const options = [];
  times(24, (hours) => {
    const mins = minsList;
    forEach(mins, (min) => {
      const timeValue = `${hours < 10 ? "0" + hours : hours}:${min}`;
      const isAfterStart = !startTime || timeValue >= startTime;
      const isBeforeEnd = !endTime || timeValue <= endTime;
      if (isAfterStart && isBeforeEnd) {
        options.push({
          value: timeValue,
          title: timeValue,
        });
      }
    });
  });

  const isAfterStart24 = !startTime || "24:00" >= startTime;
  const isBeforeEnd24 = !endTime || "24:00" <= endTime;
  if (isAfterStart24 && isBeforeEnd24) {
    options.push({ value: "24:00", title: "24:00" });
  }

  return options;
};

/// year select

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const yearOptions = Array.from({ length: 101 }, (x, index) => {
  let obj = {
    title: `${index + 2020}`,
    value: `${index + 2020}`,
  };
  return obj;
});

/// month select
export const monthOptions = monthNames.map((value) => {
  return {
    title: localeTranslator(`$vuetify.billing.${value}`),
    value: format(new Date(value + "1, " + new Date().getFullYear()), "MM"),
  };
});

export const isMoreThan24HoursAgo = (date, time) => {
  const dateTimeString = `${date} ${time}`;
  const dateTime = parse(dateTimeString, "dd MMM yyyy HH:mm", new Date(), {
    locale: enUS,
  });
  const twentyFourHoursAgo = subHours(new Date(), 24);
  return isBefore(dateTime, twentyFourHoursAgo);
};

export const transformDateKeys = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(transformDateKeys);
  } else if (obj !== null && typeof obj === "object") {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      let newKey = key;

      // Match keys in format YYYYMMDD (e.g., 20250601)
      if (/^\d{8}$/.test(key)) {
        const year = key.slice(0, 4);
        const month = key.slice(4, 6);
        const day = key.slice(6, 8);
        newKey = `${year}-${month}-${day}`;
      } else {
        newKey = humps.decamelizeKeys(key);
      }

      acc[newKey] = transformDateKeys(value);
      return acc;
    }, {});
  }
  return obj;
};
